import React from "react";

// Accordion Header
export const AccordionHeader = ({
  open,
  children,
  border,
  borderRadius,
  activeClass = "",
  inactiveClass,
  clickFun = () => {},
  isHeaderPointer = false,
}) => {
  return (
    <tr
      style={
        border
          ? {
              borderBottom: "1px solid",
              borderBottomColor: "#DDE2EB",
              ...(borderRadius
                ? {
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }
                : undefined),
            }
          : {}
      }
      className={`accordion_table_data_row ${
        open ? "active " + activeClass : inactiveClass
      } ${isHeaderPointer ? "pointer" : ""}`}
      onClick={() => {
        clickFun && clickFun();
      }}
    >
      {children}
    </tr>
  );
};

// Accordion last child
export const AccordionContent = ({
  open,
  children,
  activeClassName = "",
  id = "",
  role = "",
  ariaLabelledBy = "",
}) => {
  return (
    <div
      id={ariaLabelledBy}
      role={role}
      aria-labelledby={id}
      hidden={!open}
      className={`accordion_content_container ${
        open ? "active" : ""
      } ${activeClassName}`}
    >
      {open && children}
    </div>
  );
};

// main Accordion Parent
export const Accordion = ({ children }) => {
  return <div className="accordion_container">{children}</div>;
};
